import {Component, Inject, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FeatureFlagService} from '@ox/data';
import {RecommendedOffer, AssetType, ALaCarteCard, BML as iBML, UIFeatureFlagsEnum} from '@ox/typings';
import {BML} from '@ox/utils';
import {ShopDataService, AssetsService} from '@webu/data';
import {map, tap} from 'rxjs';

@Component({
  selector: 'webu-recommended-offers-section',
  templateUrl: './recommended-offers-section.component.html'
})
export class RecommendeOffersSectionComponent implements OnInit {

  @Input() offers: RecommendedOffer[];
  @Input() year: string;
  @Input() model: string;

  products: ALaCarteCard[];
  brand = this.bml.brand;
  backgroundType = 'dark-bg';
  subHeader:string;
  isInterimCatalogEnabled = false;

  interimCatalogFlag$ = this.featureFlagService.featureFlags$.pipe(
    map(flags => flags.UI[UIFeatureFlagsEnum.OC_INTERIM_CATALOG]),
    tap(flag => {
      this.isInterimCatalogEnabled = flag;
    })
  );
  
  constructor(
    private shopDataService: ShopDataService,
    private assetsService: AssetsService,
    @Inject(BML) private bml: iBML,
    private featureFlagService: FeatureFlagService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.subHeader = this.shopDataService.getGenericCopy('myplans.moreproducts', {year: this.year, model: this.model}) ?? '';
    this.products = [];
    const maxProducts = 4;
    for (let i = 0; (i < this.offers.length && i < maxProducts); i++) {
      const offer = this.offers[i];
      const asset = this.getPlanAsset(offer.planCode);
      const product = {
        productName: offer.planId,
        customerFinalPrice: offer.price.customerFinalPrice,
        retailPrice: offer.price.retailPrice,
        billingFrequencyCopy: offer.price.billingFrequencyCopy,
        learnMoreDestination: offer.seoUrl, 
        media: asset?.urlPath ?? '',
        bodyCopy: this.getPlanDescription(offer.planCode),
        altText: asset?.imageAltText ?? ''
      };
      this.products.push(product);
    }
    this.interimCatalogFlag$.subscribe();
  }

  getPlanDescription(planCode: string) {
    return this.shopDataService.getProductCopyByCode(planCode)?.description ?? '';
  }  
  
  getPlanAsset(planCode: string) {
    if (this.shopDataService.getProductCopyByCode(planCode)?.type === 'Data') {
      planCode = 'Unlimited Data'; //match with assets
    }
    const asset = this.assetsService.getSpecificPlanAssetByType(
      planCode, 'recommended.for.you', AssetType.Image);

    return asset;
  }

  aLaCartClick(event:any){
    if(this.isInterimCatalogEnabled) this.router.navigate([`onstar/shop/${event?.detail?.destination}`],{queryParams: {year: event?.detail?.year}});
    else this.router.navigate([`onstar/shop/${event?.detail?.destination}`]);
  }


}
